// Template209: Osaka - Día 2 Centro de Osaka y Dotonbori (Page3)
// Equivalente a Page3.jsx de guia-osaka. Datos desde page (backend).

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import SabiasQue from "../SabiasQue";

const Template209 = ({
	backgroundColor,
	textColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
	updatePage,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content;
	const titleOverlay =
		isSmallScreen && page?.data?.tituloMovil
			? page.data.tituloMovil
			: page?.texts?.[1]?.content;
	const intro = page?.texts?.[2]?.content;
	const nambaTitle = page?.texts?.[3]?.content;
	const nambaBody = page?.texts?.[4]?.content;
	const kuromonTitle = page?.texts?.[5]?.content;
	const kuromonBody = page?.texts?.[6]?.content;
	const kuromonTip = page?.texts?.[7]?.content;
	const shinsaibashiTitle = page?.texts?.[8]?.content;
	const shinsaibashiBody = page?.texts?.[9]?.content;
	const nipponbashiTitle = page?.texts?.[10]?.content;
	const nipponbashiBody = page?.texts?.[11]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const portadaImage = getImageSrc("portada");
	const portadaSticker = getCanvasImageUrl("portada-sticker");
	const nambaImage = getImageSrc("namba");
	const mercadoImage = getImageSrc("mercado");
	const mercadoSticker = getImageSrc("mercadoSticker");
	const shinsaibashiImage = getImageSrc("shinsaibashi");
	const logoImage = getCanvasImageUrl("logo");

	const sabiasQue = Array.isArray(page?.data?.sabiasQue)
		? page.data.sabiasQue
		: [];

	const actualHeaderColor = headerBackgroundColor || "#1F4E3D";

	const estiloH3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 14,
		fontWeight: 700,
		textTransform: "uppercase",
		margin: 0,
	};

	const contentColor = textColor || "#444";

	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: contentColor,
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				color: contentColor,
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *:not([data-template-header])": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
					color: "inherit",
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1,
				}}
			>
				{headerText}
				{logoImage && (
					<Box
						component="img"
						src={logoImage}
						alt="logo"
						sx={{
							width: isSmallScreen ? 66 : 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			<Box data-block-id="image-0" sx={{ position: "relative" }}>
				{portadaImage && (
					<Box
						component="img"
						src={portadaImage}
						alt=""
						sx={{ width: "100%", height: 200, objectFit: "cover" }}
					/>
				)}
				{titleOverlay && (
					<Box
						component="h1"
						sx={{
							fontSize: 32,
							textAlign: "center",
							position: "absolute",
							bottom: 0,
							margin: 1.25,
							left: 20,
							color: "#fff",
							textShadow: "2px 2px 4px rgba(0,0,0,0.6)",
						}}
					>
						{titleOverlay}
					</Box>
				)}
				{portadaSticker && (
					<Box
						component="img"
						src={portadaSticker}
						alt=""
						sx={{ width: 100, position: "absolute", bottom: 55, left: 21 }}
					/>
				)}
			</Box>

			<Box data-block-id="text-1" sx={{ padding: "10px 12px" }}>
				{intro && (
					<Box
						sx={{
							fontSize: 13,
							color: "#333",
							margin: 0,
							padding: 0,
							marginTop: "-10px",
						}}
					>
						{intro}
					</Box>
				)}

				{/* Namba Yasaka Jinja */}
				<Box
					data-block-id="text-2"
					sx={{
						backgroundColor: "#d1e6de",
						borderRadius: "12px",
						padding: "8px 16px",
						fontSize: "13px",
						marginTop: 1.5,
						textAlign: "left",
						marginBottom: isSmallScreen ? 1.25 : 0,
						color: contentColor,
						position: "relative",
					}}
				>
					<Box
						sx={{ width: isSmallScreen ? "70%" : "80%", position: "relative" }}
					>
						{nambaTitle && (
							<Box component="h3" sx={estiloH3}>
								{nambaTitle}
							</Box>
						)}
						{nambaBody && (
							<Box component="p" sx={estiloP}>
								{nambaBody}
							</Box>
						)}
					</Box>
					{nambaImage && (
						<Box
							component="img"
							src={nambaImage}
							alt=""
							sx={{
								width: 100,
								position: "absolute",
								bottom: 0,
								right: isSmallScreen ? -30 : 0,
							}}
						/>
					)}
				</Box>

				{/* Kuromon Ichiba */}
				<Box
					data-block-id="text-3"
					sx={{
						display: "flex",
						flexDirection: "column",
						gap: 2,
						marginTop: 1.5,
						position: "relative",
					}}
				>
					<Box sx={{ display: "flex", gap: 2, position: "relative" }}>
						{sabiasQue.length > 0 && (
							<Box sx={{ position: "absolute", top: 0, left: "34%" }}>
								<SabiasQue
									icono={sabiasQue[0]?.icono ?? "👨‍🍳"}
									texto={sabiasQue[0]?.texto ?? ""}
								/>
							</Box>
						)}
						{mercadoImage && (
							<Box
								component="img"
								src={mercadoImage}
								alt=""
								sx={{
									width: "40%",
									height: 110,
									objectFit: "cover",
									borderRadius: "12px",
								}}
							/>
						)}
						<Box sx={{ width: "60%" }}>
							{kuromonTitle && (
								<Box component="h3" sx={estiloH3}>
									{kuromonTitle}
								</Box>
							)}
							{kuromonBody && (
								<Box component="p" sx={estiloP}>
									{kuromonBody}
								</Box>
							)}
						</Box>
						{mercadoSticker && (
							<Box
								component="img"
								src={mercadoSticker}
								alt=""
								sx={{
									width: 100,
									position: "absolute",
									bottom: isSmallScreen ? -90 : -40,
									right: -40,
								}}
							/>
						)}
						{kuromonTip && (
							<Box
								sx={{
									position: "absolute",
									bottom: isSmallScreen ? -50 : -10,
									right: 40,
									backgroundColor: "#fff8db",
									border: "2px solid #f5c400",
									borderRadius: "16px 16px 0px 16px",
									padding: "10px 12px",
									fontSize: 11,
									color: contentColor,
									boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
									maxWidth: 160,
								}}
								dangerouslySetInnerHTML={{ __html: kuromonTip }}
							/>
						)}
					</Box>

					{/* Shinsaibashi */}
					<Box
						sx={{
							display: "flex",
							gap: 2,
							position: "relative",
							marginTop: isSmallScreen ? 8 : 0,
						}}
					>
						{shinsaibashiImage && (
							<Box
								component="img"
								src={shinsaibashiImage}
								alt=""
								sx={{
									width: "40%",
									height: 110,
									objectFit: "cover",
									borderRadius: "12px",
								}}
							/>
						)}
						<Box sx={{ width: "60%" }}>
							{shinsaibashiTitle && (
								<Box component="h3" sx={estiloH3}>
									{shinsaibashiTitle}
								</Box>
							)}
							{shinsaibashiBody && (
								<Box component="p" sx={estiloP}>
									{shinsaibashiBody}
								</Box>
							)}
						</Box>
					</Box>

					{/* Nipponbashi */}
					{(nipponbashiTitle || nipponbashiBody) && (
						<Box
							sx={{
								backgroundColor: "#d1e6de",
								border: "3px solid #1F4E3D",
								borderRadius: "12px",
								padding: "8px 20px",
								fontSize: 12,
								color: "#333",
							}}
						>
							{nipponbashiTitle && (
								<Box
									component="h4"
									sx={{
										margin: 0,
										marginBottom: 0.5,
										fontSize: 14,
										fontWeight: 700,
										color: contentColor,
										textTransform: "uppercase",
									}}
								>
									{nipponbashiTitle}
								</Box>
							)}
							{nipponbashiBody && (
								<Box component="p" sx={estiloP}>
									{nipponbashiBody}
								</Box>
							)}
						</Box>
					)}
				</Box>
			</Box>
		</Box>
	);
};

Template209.thumbnail = "/images/template-1.png";

export default Template209;
